import React, { useState, useEffect, useContext } from 'react';

const Tags = ({ tags, setTags }) => {

    //sort tags alphabetically
    let sortedTags = [...(tags || [])].sort((a, b) => a.localeCompare(b));

    return <div style={{ border: "1px solid #ccc", marginBottom: 10, borderRadius: 4, boxSizing: "border-box", width: "100%", padding: 4 }}>
        <div style={{ display: "flex", gap: 4, alignItems: "center", padding: "0" }}>

            {(tags || []).map((tag, i) => <div key={i} style={{ border: "1px outset #ccc", padding: 2, borderRadius: 4, display: "flex", gap: 10 }}>
                <i className="fas fa-times" style={{ cursor: "pointer" }} onClick={() => setTags(tags.filter((t, j) => i !== j))}></i>
                <input style={{
                    border: "none",
                    width: 80,
                }}
                    type="text" value={tag} onChange={e => setTags(tags.map((t, j) => i === j ? e.target.value : t))} />
            </div>)}

            <button onClick={() => setTags([...tags, ""])}>Add Tag</button>

        </div>
    </div>;

}

export default Tags;